import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from "@angular/router";
import { LmwCommonModule } from '../lmw-common/lmw-common.module';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { HelpComponent } from './components/help/help.component';
import { AppComponent } from './app.component';
import { BrowseSubjectsComponent } from './components/browse-subjects/browse-subjects.component';
import { BrowseTopicsComponent } from './components/browse-topics/browse-topics.component';
import { ReportAnIssueComponent } from './components/report-an-issue/report-an-issue.component';
import { CookiesComponent } from './components/cookies/cookies.component';
import { FooterBaseComponent } from './components/footer-base/footer-base.component'
import { HeaderBaseComponent } from './components/header-base/header-base.component';
import { HomeComponent } from './components/home/home.component';
import { MobileRegisterSignInBarComponent } from './components/mobile-register-sign-in-bar/mobile-register-sign-in-bar.component';
import { PrivacyComponent } from './components/privacy/privacy.component';
import { TermsAndConditionsComponent } from './components/terms-and-conditions/terms-and-conditions.component';
import { AccessibilityComponent } from './components/accessibility/accessibility.component';
import { TopicLandingComponent } from './components/topic-landing/topic-landing.component';
import { MyLearningHomeComponent } from './components/my-learning/my-learning-home/my-learning-home.component';

import { LmwBaseStates } from './routing/lmw-base.states';
import { UserSignedInResolver } from './services/user-signed-in.resolver';
import { CaseStudyComponent } from './components/case-study/case-study.component';
import { BreadcrumbAndNavigationComponent } from './components/breadcrumb-and-navigation/breadcrumb-and-navigation.component';


@NgModule({
  imports: [
    CommonModule,
    LmwCommonModule,
    HttpClientModule,
    ReactiveFormsModule,
    RouterModule.forChild([...LmwBaseStates]),
  ],
  declarations: [
    AppComponent,
    BrowseSubjectsComponent,
    BrowseTopicsComponent,
    ReportAnIssueComponent,
    CookiesComponent,
    FooterBaseComponent,
    HeaderBaseComponent,
    HomeComponent,
    HelpComponent,
    MobileRegisterSignInBarComponent,
    PrivacyComponent,
    TermsAndConditionsComponent,
    TopicLandingComponent,
    MyLearningHomeComponent,
    CaseStudyComponent,
    BreadcrumbAndNavigationComponent,
    AccessibilityComponent
  ],
  providers: [UserSignedInResolver]
})
export class LmwBaseModule {}
